import React, { useState } from 'react';
import { ArrowRight, Bell, Calendar, MessageSquare, User, Settings, LogOut, Users, Coffee, Edit, Zap, UserPlus, Briefcase, HelpCircle, X, ChevronDown, Home, Users as UsersIcon, Globe, Share2, Link, Copy, Facebook, Twitter, Linkedin, Instagram, Lock, Globe as GlobeIcon, CheckCircle2, Leaf } from 'lucide-react';
import './styles.css';
import { EmptyState } from './EmptyState';
import { useNavigate } from 'react-router-dom';
export function MemberHomePage() {
  // For demo purposes, we'll create state variables to toggle between content and empty states
  const [hasConnections, setHasConnections] = useState(true);
  const [hasEvents, setHasEvents] = useState(true);
  const [hasActivities, setHasActivities] = useState(true);
  const [hasSuggestions, setHasSuggestions] = useState(true);
  const [showMatchInfo, setShowMatchInfo] = useState<{
    show: boolean;
    name: string;
    match: string;
    closing: boolean;
  }>({
    show: false,
    name: '',
    match: '',
    closing: false
  });
  const [showShareModal, setShowShareModal] = useState<{
    show: boolean;
    closing: boolean;
  }>({
    show: false,
    closing: false
  });
  const [showPublicProfile, setShowPublicProfile] = useState<{
    show: boolean;
    closing: boolean;
  }>({
    show: false,
    closing: false
  });
  const [showImpactSuggestions, setShowImpactSuggestions] = useState<{
    show: boolean;
    closing: boolean;
  }>({
    show: false,
    closing: false
  });
  const [activeTab, setActiveTab] = useState<'brief' | 'deep'>('brief');
  const [privacyOption, setPrivacyOption] = useState<'private' | 'public'>('public');
  const [copySuccess, setCopySuccess] = useState(false);
  const navigate = useNavigate();
  // Function to handle profile click and navigate to profile page
  const handleProfileClick = username => {
    // Convert the username to a URL-friendly format (replace spaces with dashes, lowercase)
    const formattedUsername = username.toLowerCase().replace(/\s+/g, '-');
    navigate(`/profile/${formattedUsername}`);
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText('https://thesocialhub.com/profile/sophia');
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };
  const closeShareModal = () => {
    setShowShareModal({
      ...showShareModal,
      closing: true
    });
    setTimeout(() => {
      setShowShareModal({
        show: false,
        closing: false
      });
    }, 300);
  };
  const openPublicProfile = () => {
    // Navigate to the public profile page in the same tab
    navigate('/profile/sophia');
  };
  const closePublicProfile = () => {
    setShowPublicProfile({
      ...showPublicProfile,
      closing: true
    });
    setTimeout(() => {
      setShowPublicProfile({
        show: false,
        closing: false
      });
    }, 300);
  };
  return <div className="flex flex-col min-h-screen w-full bg-white text-black font-sans" data-id="element-1395">
      {/* Hero section with black background */}
      <section className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] bg-black text-white pt-4 pb-6 md:pt-6 md:pb-8" data-id="element-1396">
        <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-1397">
          <div className="flex flex-col items-center text-center gap-6" data-id="element-1398">
            {/* User profile image */}
            <div className="flex-shrink-0" data-id="element-1399">
              <div className="relative" data-id="element-1400">
                <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-2 border-gray-200" data-id="element-1401">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/woFngADa1aU2Q5MqNXmffj/pexels-olly-774909.jpg" alt="Profile" className="w-full h-full object-cover ring-4 ring-purple-500 ring-offset-2 ring-offset-black" data-id="element-1402" />
                </div>
                <div className="absolute bottom-3 right-3 w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => setShowShareModal({
                show: true,
                closing: false
              })} data-id="element-1403">
                  <Share2 className="w-4 h-4 md:w-5 md:h-5 text-black" data-id="element-1404" />
                </div>
              </div>
            </div>
            {/* User info */}
            <div className="flex-grow" data-id="element-1405">
              <h1 className="text-2xl md:text-3xl font-light mb-1 font-sharp-grotesk" data-id="element-1406">
                <span className="mr-2" data-id="element-1407">👋</span>Welcome, Sophia
              </h1>
              <p className="text-gray-400 font-medium mb-2" data-id="element-1408">
                Premium Membership • Rome
              </p>
              {/* Quick stats */}
              <div className="grid grid-cols-3 md:grid-cols-3 gap-4 mt-6 border-t border-gray-800 pt-4 w-full" data-id="element-1409">
                <div className="text-center" data-id="element-1410">
                  <p className="text-2xl font-light font-sharp-grotesk" data-id="element-1411">85%</p>
                  <p className="text-xs text-gray-400 tracking-wider" data-id="element-1412">
                    Community Impact
                  </p>
                </div>
                <div className="text-center" data-id="element-1413">
                  <p className="text-2xl font-light font-sharp-grotesk" data-id="element-1414">24</p>
                  <p className="text-xs text-gray-400 tracking-wider" data-id="element-1415">
                    Matching Count
                  </p>
                </div>
                <div className="text-center" data-id="element-1416">
                  <p className="text-2xl font-light font-sharp-grotesk" data-id="element-1417">7</p>
                  <p className="text-xs text-gray-400 tracking-wider" data-id="element-1418">
                    Collaboration Count
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Main content with white background */}
      <section className="flex-grow bg-white py-6 md:py-10" data-id="element-1419">
        <div className="max-w-6xl mx-auto" data-id="element-1420">
          {/* Recent Actions section */}

          {/* My Connections section */}
          <div className="mb-6" data-id="element-1421">
            <div className="flex justify-between items-center mb-4" data-id="element-1422">
              <h2 className="text-xl md:text-2xl font-sharp-grotesk" data-id="element-1423">
                My Connections
              </h2>
              <a href="/connections" className="text-gray-500 font-light flex items-center text-sm hover:text-black transition-colors" data-id="element-1424">
                View all <ArrowRight className="w-4 h-4 ml-1" data-id="element-1425" />
              </a>
            </div>
            {hasConnections ? <div className="carousel-container relative group" data-id="element-1426">
                <div className="carousel-wrapper overflow-hidden" data-id="element-1427">
                  <div className="carousel-items py-0" id="connectionCarousel" data-id="element-1428">
                    {[{
                  name: 'Giulia Verdi',
                  role: 'Web Developer',
                  match: '92%',
                  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gou2Ede34nLvCQizNZLz4q/irene-strong--FOUPtqP-mY-unsplash.jpg'
                }, {
                  name: 'Roberto Neri',
                  role: 'Marketing',
                  match: '78%',
                  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/37RNAboQN8qk3BnTK1YzhT/irene-strong-TMt3JGoVlng-unsplash.jpg'
                }, {
                  name: 'Marco Bianchi',
                  role: 'UX Designer',
                  match: '85%',
                  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rpDp7vdFb4PQ6LshFeTqC4/christian-buehner-zYD6ou1Qj10-unsplash.jpg'
                }, {
                  name: 'Laura Rossi',
                  role: 'Product Manager',
                  match: '90%',
                  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iiGCarC4BpomqUoZERcuSH/jurica-koletic-7YVZYZeITc8-unsplash.jpg'
                }, {
                  name: 'Andrea Marino',
                  role: 'Data Scientist',
                  match: '82%',
                  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bc8MUYcKAT6QrAiyMeUwXx/christian-buehner-DItYlc26zVI-unsplash.jpg'
                }].map(user => <div key={user.name} className="carousel-card !rounded-md" onClick={() => handleProfileClick(user.name)} role="button" aria-label={`View profile of ${user.name}`} tabIndex={0} data-id="element-1429">
                        <div className="card-image" data-id="element-1430">
                          <img src={user.image} alt={user.name} className="w-full h-full object-cover" data-id="element-1431" />
                        </div>
                        <div className="card-content p-0 px-3 pt-2 pb-3" data-id="element-1432">
                          <h3 className="card-title" data-id="element-1433">{user.name}</h3>
                          <p className="card-subtitle" data-id="element-1434">{user.role}</p>
                          <div className="flex items-center gap-1" data-id="element-1435">
                            <div className="flex items-center bg-white border border-gray-200 rounded-lg px-2.5 py-1" data-id="element-1436">
                              <span className="text-gray-700 text-xs font-medium" data-id="element-1437">
                                {user.match} match
                              </span>
                            </div>
                            <button className="p-1 hover:bg-gray-100 rounded-full transition-colors" onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowMatchInfo({
                          show: true,
                          name: user.name,
                          match: user.match,
                          closing: false
                        });
                      }} aria-label={`Match information with ${user.name}`} data-id="element-1438">
                              <HelpCircle className="w-3.5 h-3.5 text-gray-700" data-id="element-1439" />
                            </button>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
                <button className="carousel-nav-button carousel-prev" aria-label="Previous slide" data-id="element-1440">
                  <div className="nav-button-inner" data-id="element-1441">
                    <ChevronDown className="w-5 h-5 rotate-90" data-id="element-1442" />
                  </div>
                </button>
                <button className="carousel-nav-button carousel-next" aria-label="Next slide" data-id="element-1443">
                  <div className="nav-button-inner" data-id="element-1444">
                    <ChevronDown className="w-5 h-5 -rotate-90" data-id="element-1445" />
                  </div>
                </button>
                <div className="carousel-indicators" data-id="element-1446">
                  <div className="carousel-dots" data-id="element-1447">
                    {[...Array(5)].map((_, index) => <span key={index} className={`carousel-dot ${index === 0 ? 'active' : ''}`} role="button" aria-label={`Go to card ${index + 1}`} tabIndex={0} data-id="element-1448"></span>)}
                  </div>
                </div>
              </div> : <EmptyState emoji="👥" title="No connections yet" description="Start connecting with other community members to expand your professional network." actionLabel="Find people" onAction={() => setHasConnections(true)} data-id="element-1449" />}
          </div>
          {/* AI Suggestions section */}
          <div className="mt-10 mb-6" data-id="element-1450">
            <div className="flex justify-between items-center mb-4" data-id="element-1451">
              <h2 className="text-xl md:text-2xl font-sharp-grotesk" data-id="element-1452">
                AI Suggestions
              </h2>
              <div className="flex items-center bg-gray-100 rounded-full px-3 py-1" data-id="element-1453">
                <Zap className="w-4 h-4 text-yellow-500 mr-1" data-id="element-1454" />
                <span className="text-xs font-medium" data-id="element-1455">Powered by AI</span>
              </div>
            </div>
            {hasSuggestions ? <div className="space-y-4" data-id="element-1456">
                <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1457">
                  <div className="p-5 flex flex-col" data-id="element-1458">
                    <div className="flex mb-4 justify-start items-center" data-id="element-1459">
                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-2 relative" data-id="element-1460">
                        <img src="https://randomuser.me/api/portraits/men/85.jpg" alt="Blockchain Expert" className="w-full h-full object-cover" data-id="element-1461" />
                      </div>
                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-1 relative -ml-6" data-id="element-1462">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bPxviaDF98Buy2nnayRr63/vinicius-amnx-amano-0NCjjD0zGnw-unsplash_%281%29.jpg" alt="Blockchain Expert" className="w-full h-full object-cover" data-id="element-1463" />
                      </div>
                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-0 relative -ml-6" data-id="element-1464">
                        <img src="https://randomuser.me/api/portraits/men/92.jpg" alt="Blockchain Expert" className="w-full h-full object-cover" data-id="element-1465" />
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-1466">
                      <div className="mb-1" data-id="element-1467">
                        <h3 className="font-medium font-sharp-grotesk" data-id="element-1468">
                          Networking Opportunity
                        </h3>
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1469">
                        Today there are 3 people in the Hub who work with
                        Blockchain. Would you like to organize a Topic Lunch
                        with them?
                      </p>
                      <div className="flex flex-col space-y-2" data-id="element-1470">
                        <button className="text-sm font-medium text-white bg-black px-4 py-1.5 rounded-lg flex items-center gap-1 w-fit" data-id="element-1471">
                          <Calendar className="w-4 h-4" data-id="element-1472" /> Organize
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1473">
                  <div className="p-5 flex flex-col" data-id="element-1474">
                    <div className="flex justify-start items-center mb-4" data-id="element-1475">
                      <div className="relative w-12 h-12 flex-shrink-0" data-id="element-1476">
                        <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Marco B." className="w-12 h-12 rounded-full object-cover border-2 border-gray-200" data-id="element-1477" />
                        <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-200 w-6 h-6 flex items-center justify-center" data-id="element-1478">
                          <span className="text-sm" role="img" aria-label="collaboration" data-id="element-1479">
                            🤝
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex-1" data-id="element-1480">
                      <div className="mb-1" data-id="element-1481">
                        <h3 className="font-medium font-sharp-grotesk" data-id="element-1482">
                          Skills Match
                        </h3>
                      </div>
                      <p className="text-sm text-gray-600 mb-4 font-normal" data-id="element-1483">
                        Your UX/UI design skills could be useful for Marco B.'s
                        project. Would you like to learn more?
                      </p>
                      <div className="flex flex-col space-y-2" data-id="element-1484">
                        <button className="text-sm font-medium text-white bg-black px-4 py-1.5 rounded-lg flex items-center gap-1 w-fit" data-id="element-1485">
                          <ArrowRight className="w-4 h-4" data-id="element-1486" /> Discover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div> : <EmptyState emoji="💡" title="No suggestions available" description="Personalized suggestions will appear here as you interact with the community." actionLabel="Update profile" onAction={() => setHasSuggestions(true)} data-id="element-1487" />}
          </div>
          {/* Increase Your Impact section */}
          <div className="mb-6" data-id="element-1488">
            <div className="mb-4" data-id="element-1489">
              <h2 className="text-xl md:text-2xl font-sharp-grotesk" data-id="element-1490">
                Increase Your Impact
              </h2>
              <div className="flex items-center bg-gray-100 rounded-full px-3 py-1 mt-2 w-fit" data-id="element-1491">
                <span className="text-xs font-medium" data-id="element-1492">Current index: 85%</span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1493">
              <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm mb-4" data-id="element-1494">
                <div className="flex gap-4" data-id="element-1495">
                  <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1496">
                    <Briefcase className="w-5 h-5 text-gray-700" data-id="element-1497" />
                  </div>
                  <div className="flex-1" data-id="element-1498">
                    <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1499">
                      Collaborate with Marco B.
                    </h3>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-1500">
                      His Blockchain project needs your skills!
                    </p>
                    <div className="mb-3" data-id="element-1501">
                      <div className="flex justify-between items-center mb-1" data-id="element-1502">
                        <span className="text-xs text-gray-500" data-id="element-1503">
                          Potential impact
                        </span>
                        <span className="text-xs font-medium" data-id="element-1504">+3%</span>
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1505">
                        <div className="bg-gray-400 h-1.5 rounded-full" style={{
                        width: '3%'
                      }} data-id="element-1506"></div>
                      </div>
                    </div>
                    <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg flex items-center gap-1 w-fit" data-id="element-1507">
                      Contact Marco
                    </button>
                  </div>
                </div>
              </div>
              <button className="w-full py-3 border border-gray-300 rounded-lg flex items-center justify-center text-sm font-medium hover:bg-gray-50 transition-colors" onClick={() => setShowImpactSuggestions({
              show: true,
              closing: false
            })} data-id="element-1508">
                <span data-id="element-1509">See all suggestions</span>
                <ArrowRight className="w-4 h-4 ml-2" data-id="element-1510" />
              </button>
            </div>
            {/* Impact Suggestions Modal */}
            {showImpactSuggestions.show && <div className="fixed inset-0 z-50 flex items-end justify-center" data-id="element-1511">
                <div className="fixed inset-0 bg-black/30 transition-opacity" onClick={() => {
              setShowImpactSuggestions({
                ...showImpactSuggestions,
                closing: true
              });
              setTimeout(() => {
                setShowImpactSuggestions({
                  show: false,
                  closing: false
                });
              }, 300);
            }} data-id="element-1512"></div>
                <div className={`bg-white w-full max-w-4xl rounded-t-xl overflow-hidden transform transition-all duration-300 ease-out h-3/4 ${showImpactSuggestions.closing ? 'animate-slide-down' : 'animate-slide-up'}`} data-id="element-1513">
                  <div className="p-6 flex flex-col h-full" data-id="element-1514">
                    <div className="flex items-center justify-between mb-6" data-id="element-1515">
                      <h3 className="text-xl font-medium font-sharp-grotesk" data-id="element-1516">
                        Improve Your Impact
                      </h3>
                      <button onClick={() => {
                    setShowImpactSuggestions({
                      ...showImpactSuggestions,
                      closing: true
                    });
                    setTimeout(() => {
                      setShowImpactSuggestions({
                        show: false,
                        closing: false
                      });
                    }, 300);
                  }} className="text-gray-500 hover:text-gray-700" data-id="element-1517">
                        <X className="w-5 h-5" data-id="element-1518" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2 mb-6" data-id="element-1519">
                      <div className="flex-1 h-1 bg-gray-100 rounded-full" data-id="element-1520">
                        <div className="h-1 bg-black rounded-full" style={{
                      width: '85%'
                    }} data-id="element-1521"></div>
                      </div>
                      <span className="text-sm font-medium" data-id="element-1522">85%</span>
                    </div>
                    <div className="overflow-y-auto flex-1 pr-2" data-id="element-1523">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1524">
                        {/* Suggestion 1 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1525">
                          <div className="flex gap-4" data-id="element-1526">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1527">
                              <Briefcase className="w-5 h-5 text-gray-700" data-id="element-1528" />
                            </div>
                            <div className="flex-1" data-id="element-1529">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1530">
                                Collaborate with Marco B.
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1531">
                                His Blockchain project needs your skills!
                              </p>
                              <div className="mb-3" data-id="element-1532">
                                <div className="flex justify-between items-center mb-1" data-id="element-1533">
                                  <span className="text-xs text-gray-500" data-id="element-1534">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1535">
                                    +3%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1536">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '3%'
                              }} data-id="element-1537"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1538">
                                Contact Marco
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Suggestion 2 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1539">
                          <div className="flex gap-4" data-id="element-1540">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1541">
                              <Calendar className="w-5 h-5 text-gray-700" data-id="element-1542" />
                            </div>
                            <div className="flex-1" data-id="element-1543">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1544">
                                Attend Workshop
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1545">
                                UX/UI Design workshop on May 20
                              </p>
                              <div className="mb-3" data-id="element-1546">
                                <div className="flex justify-between items-center mb-1" data-id="element-1547">
                                  <span className="text-xs text-gray-500" data-id="element-1548">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1549">
                                    +5%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1550">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '5%'
                              }} data-id="element-1551"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1552">
                                Sign up
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Suggestion 3 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1553">
                          <div className="flex gap-4" data-id="element-1554">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1555">
                              <MessageSquare className="w-5 h-5 text-gray-700" data-id="element-1556" />
                            </div>
                            <div className="flex-1" data-id="element-1557">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1558">
                                Mentorship Program
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1559">
                                Become a mentor for junior designers
                              </p>
                              <div className="mb-3" data-id="element-1560">
                                <div className="flex justify-between items-center mb-1" data-id="element-1561">
                                  <span className="text-xs text-gray-500" data-id="element-1562">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1563">
                                    +8%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1564">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '8%'
                              }} data-id="element-1565"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1566">
                                Apply now
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Suggestion 4 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1567">
                          <div className="flex gap-4" data-id="element-1568">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1569">
                              <Users className="w-5 h-5 text-gray-700" data-id="element-1570" />
                            </div>
                            <div className="flex-1" data-id="element-1571">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1572">
                                Host a Topic Lunch
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1573">
                                Share your UX/UI expertise with the community
                              </p>
                              <div className="mb-3" data-id="element-1574">
                                <div className="flex justify-between items-center mb-1" data-id="element-1575">
                                  <span className="text-xs text-gray-500" data-id="element-1576">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1577">
                                    +6%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1578">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '6%'
                              }} data-id="element-1579"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1580">
                                Schedule
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Suggestion 5 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1581">
                          <div className="flex gap-4" data-id="element-1582">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1583">
                              <Coffee className="w-5 h-5 text-gray-700" data-id="element-1584" />
                            </div>
                            <div className="flex-1" data-id="element-1585">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1586">
                                Networking Coffee
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1587">
                                Meet 3 new members with similar interests
                              </p>
                              <div className="mb-3" data-id="element-1588">
                                <div className="flex justify-between items-center mb-1" data-id="element-1589">
                                  <span className="text-xs text-gray-500" data-id="element-1590">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1591">
                                    +4%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1592">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '4%'
                              }} data-id="element-1593"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1594">
                                Join
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Suggestion 6 */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1595">
                          <div className="flex gap-4" data-id="element-1596">
                            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1597">
                              <Edit className="w-5 h-5 text-gray-700" data-id="element-1598" />
                            </div>
                            <div className="flex-1" data-id="element-1599">
                              <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-1600">
                                Complete Your Profile
                              </h3>
                              <p className="text-sm text-gray-600 mb-2" data-id="element-1601">
                                Add more skills and work examples
                              </p>
                              <div className="mb-3" data-id="element-1602">
                                <div className="flex justify-between items-center mb-1" data-id="element-1603">
                                  <span className="text-xs text-gray-500" data-id="element-1604">
                                    Potential impact
                                  </span>
                                  <span className="text-xs font-medium" data-id="element-1605">
                                    +2%
                                  </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-1606">
                                  <div className="bg-black h-1.5 rounded-full" style={{
                                width: '2%'
                              }} data-id="element-1607"></div>
                                </div>
                              </div>
                              <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-1608">
                                Edit profile
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-1609">
                      <p className="text-sm text-gray-500" data-id="element-1610">
                        Completing these actions can increase your community
                        impact score and improve your visibility within The
                        Social Hub.
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
          {/* Recent activities section */}
          <div className="mb-6" data-id="element-1611">
            <div className="flex justify-between items-center mb-4" data-id="element-1612">
              <h2 className="text-xl md:text-2xl font-sharp-grotesk" data-id="element-1613">
                Recent Activities
              </h2>
              <a href="#" className="text-gray-500 font-light flex items-center text-sm" data-id="element-1614">
                View all <ArrowRight className="w-4 h-4 ml-1" data-id="element-1615" />
              </a>
            </div>
            {hasActivities ? (<div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1616">
                  <div className="flex gap-4" data-id="element-1617">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1618">
                      <Calendar className="w-5 h-5 text-gray-700" data-id="element-1619" />
                    </div>
                    <div data-id="element-1620">
                      <h3 className="font-medium font-sharp-grotesk" data-id="element-1621">
                        Check-in completed
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-1622">
                        You have checked in to the coworking area
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-1623">Today, 09:15</p>
                    </div>
                  </div>
                </div>, <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1624">
                  <div className="flex gap-4" data-id="element-1625">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1626">
                      <MessageSquare className="w-5 h-5 text-gray-700" data-id="element-1627" />
                    </div>
                    <div data-id="element-1628">
                      <h3 className="font-medium font-sharp-grotesk" data-id="element-1629">
                        New message
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-1630">
                        Marco has shared a new event in the community
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-1631">
                        Yesterday, 18:30
                      </p>
                    </div>
                  </div>
                </div>, <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1632">
                  <div className="flex gap-4" data-id="element-1633">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1634">
                      <Calendar className="w-5 h-5 text-gray-700" data-id="element-1635" />
                    </div>
                    <div data-id="element-1636">
                      <h3 className="font-medium font-sharp-grotesk" data-id="element-1637">
                        Booking confirmed
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-1638">
                        "Milan" meeting room for Thursday, October 28
                      </p>
                      <p className="text-xs text-gray-400 mt-1" data-id="element-1639">
                        2 days ago, 14:22
                      </p>
                    </div>
                  </div>
                </div>) : <EmptyState emoji="🕰️" title="No recent activities" description="Your recent activities will appear here when you start using community services." actionLabel="Explore services" onAction={() => setHasActivities(true)} data-id="element-1640" />}
          </div>
          {/* Upcoming events section */}
          <div className="mb-8" data-id="element-1641">
            <div className="flex justify-between items-center mb-4" data-id="element-1642">
              <h2 className="text-xl font-bold font-sharp-grotesk" data-id="element-1643">
                Upcoming Events
              </h2>
              <a href="#" className="text-gray-500 font-light flex items-center text-sm" data-id="element-1644">
                View all <ArrowRight className="w-4 h-4 ml-1" data-id="element-1645" />
              </a>
            </div>
            <div className="grid grid-cols-1 gap-4" data-id="element-1646">
              <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1647">
                <div className="relative overflow-hidden h-40 rounded-t-lg" data-id="element-1648">
                  <img src="https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F1047381583%2F2586066230221%2F1%2Foriginal.20250606-130645?crop=focalpoint&fit=crop&w=940&auto=format%2Ccompress&q=75&sharp=10&fp-x=0.491477272727&fp-y=0.110894941634&s=3bcd5733f6b374a8350afadc66088d68" alt="Pitch Competition" className="w-full h-full object-cover" data-id="element-1649" />
                </div>
                <div className="p-4" data-id="element-1650">
                  <p className="font-bold font-sharp-grotesk text-sm md:text-base mb-2" data-id="element-1651">
                    Pitch Competition
                  </p>
                  <div className="flex items-center text-gray-600 text-xs md:text-sm font-rubik" data-id="element-1652">
                    <span className="mr-3" data-id="element-1653">May 22</span>
                    <span data-id="element-1654">14:00 - 17:00</span>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1655">
                <div className="relative overflow-hidden h-40 rounded-t-lg" data-id="element-1656">
                  <img src="https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F994889213%2F2586066230221%2F1%2Foriginal.20250328-090908?crop=focalpoint&fit=crop&w=940&auto=format%2Ccompress&q=75&sharp=10&fp-x=0.5&fp-y=0.5&s=a28ffbc9d85afe166534fa5cdfc448a3" alt="Pitch Competition" className="w-full h-full object-cover" data-id="element-1657" />
                </div>
                <div className="p-4" data-id="element-1658">
                  <p className="font-bold font-sharp-grotesk text-sm md:text-base mb-2" data-id="element-1659">
                    Pitch Competition
                  </p>
                  <div className="flex items-center text-gray-600 text-xs md:text-sm font-rubik" data-id="element-1660">
                    <span className="mr-3" data-id="element-1661">May 22</span>
                    <span data-id="element-1662">14:00 - 17:00</span>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-1663">
                <div className="relative overflow-hidden h-40 rounded-t-lg" data-id="element-1664">
                  <img src="https://images.unsplash.com/photo-1558403194-611308249627?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Digital Marketing Masterclass" className="w-full h-full object-cover" data-id="element-1665" />
                </div>
                <div className="p-4" data-id="element-1666">
                  <p className="font-bold font-sharp-grotesk text-sm md:text-base mb-2" data-id="element-1667">
                    Digital Marketing Masterclass
                  </p>
                  <div className="flex items-center text-gray-600 text-xs md:text-sm font-rubik" data-id="element-1668">
                    <span className="mr-3" data-id="element-1669">May 28</span>
                    <span data-id="element-1670">10:00 - 12:30</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mobile bottom navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3 z-50" data-id="element-1671">
        <a href="/" className="flex flex-col items-center" data-id="element-1672">
          <Home className="w-5 h-5 text-black" data-id="element-1673" />
          <span className="text-xs mt-1" data-id="element-1674">Home</span>
        </a>
        <a href="/connections" className="flex flex-col items-center" data-id="element-1675">
          <UsersIcon className="w-5 h-5 text-gray-400" data-id="element-1676" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1677">Connections</span>
        </a>
        <a href="/networking" className="flex flex-col items-center" data-id="element-1678">
          <Globe className="w-5 h-5 text-gray-400" data-id="element-1679" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1680">Networking</span>
        </a>
        <a href="/collaboration" className="flex flex-col items-center" data-id="element-1681">
          <Briefcase className="w-5 h-5 text-gray-400" data-id="element-1682" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1683">Collaboration</span>
        </a>
        <a href="/impact" className="flex flex-col items-center" data-id="element-1684">
          <Leaf className="w-5 h-5 text-gray-400" data-id="element-1685" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1686">Impact</span>
        </a>
      </div>
      {/* Match Info Modal */}
      {showMatchInfo.show && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center" data-id="element-1687">
          <div className="fixed inset-0 bg-black/30 transition-opacity" onClick={() => {
        setShowMatchInfo({
          ...showMatchInfo,
          closing: true
        });
        setTimeout(() => {
          setShowMatchInfo({
            show: false,
            name: '',
            match: '',
            closing: false
          });
        }, 300); // Match animation duration
      }} data-id="element-1688"></div>
          <div className={`bg-white w-full max-w-md rounded-t-xl sm:rounded-xl overflow-hidden transform transition-all duration-300 ease-out ${showMatchInfo.closing ? 'animate-slide-down' : 'animate-slide-up'}`} data-id="element-1689">
            <div className="max-h-[75vh] overflow-y-auto p-6" data-id="element-1690">
              {/* Header with more prominent match percentage */}
              <div className="flex justify-between items-start mb-6" data-id="element-1691">
                <div data-id="element-1692">
                  <h3 className="text-xl font-medium font-sharp-grotesk mb-1" data-id="element-1693">
                    Match with {showMatchInfo.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1694">
                    See why you're compatible
                  </p>
                </div>
                <button onClick={() => {
              setShowMatchInfo({
                ...showMatchInfo,
                closing: true
              });
              setTimeout(() => {
                setShowMatchInfo({
                  show: false,
                  name: '',
                  match: '',
                  closing: false
                });
              }, 300); // Match animation duration
            }} className="text-gray-500 hover:text-gray-700" data-id="element-1695">
                  <X className="w-5 h-5" data-id="element-1696" />
                </button>
              </div>
              {/* Large match percentage indicator - now with gray background instead of black */}
              <div className="py-0 mb-6" data-id="element-1697">
                <div className="flex-shrink-0 mb-2" data-id="element-1698">
                  <span className="text-gray-900 text-3xl font-bold font-sharp-grotesk" data-id="element-1699">
                    {showMatchInfo.match}
                  </span>
                </div>
                <div data-id="element-1700">
                  <h4 className="font-medium text-base mb-1" data-id="element-1701">Match Score</h4>
                  <p className="text-sm text-gray-600" data-id="element-1702">
                    You have a strong compatibility based on multiple factors
                  </p>
                </div>
              </div>
              <div className="mb-4" data-id="element-1703">
                <div className="flex items-center space-x-2 mb-6 border-b border-gray-200 pb-2" data-id="element-1704">
                  <button className={`px-4 py-2 ${activeTab === 'brief' ? 'bg-black text-white' : 'text-gray-500'} rounded-full text-sm font-medium transition-colors duration-300`} onClick={() => setActiveTab('brief')} data-id="element-1705">
                    Brief
                  </button>
                  <button className={`px-4 py-2 ${activeTab === 'deep' ? 'bg-black text-white' : 'text-gray-500'} rounded-full text-sm font-medium transition-colors duration-300`} onClick={() => setActiveTab('deep')} data-id="element-1706">
                    Deep dive
                  </button>
                </div>
                <div className="relative overflow-hidden" data-id="element-1707">
                  <div className={`transition-all duration-300 ${activeTab === 'brief' ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-[-100%] absolute top-0 left-0 right-0'}`} data-id="element-1708">
                    <h4 className="font-medium text-lg mb-3 font-sharp-grotesk" data-id="element-1709">
                      Why we matched you
                    </h4>
                    <ul className="space-y-4 mb-6" data-id="element-1710">
                      <li className="flex items-start p-2 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1711">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-1712">
                          <span className="text-xs font-medium" data-id="element-1713">1</span>
                        </div>
                        <p className="text-sm" data-id="element-1714">
                          <strong data-id="element-1715">Role:</strong> {showMatchInfo.name} has a role
                          complementary to yours, which can lead to productive
                          collaborations.
                        </p>
                      </li>
                      <li className="flex items-start p-2 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1716">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-1717">
                          <span className="text-xs font-medium" data-id="element-1718">2</span>
                        </div>
                        <p className="text-sm" data-id="element-1719">
                          <strong data-id="element-1720">Sector:</strong> You both work in the
                          consulting sector, sharing specific market knowledge.
                        </p>
                      </li>
                      <li className="flex items-start p-2 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1721">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-1722">
                          <span className="text-xs font-medium" data-id="element-1723">3</span>
                        </div>
                        <p className="text-sm" data-id="element-1724">
                          <strong data-id="element-1725">Skills:</strong> You have similar skills in
                          software development.
                        </p>
                      </li>
                      <li className="flex items-start p-2 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1726">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-1727">
                          <span className="text-xs font-medium" data-id="element-1728">4</span>
                        </div>
                        <p className="text-sm" data-id="element-1729">
                          <strong data-id="element-1730">Company type:</strong> You both work in
                          startups, with similar organizational dynamics.
                        </p>
                      </li>
                    </ul>
                    <h4 className="font-medium text-lg mb-3 font-sharp-grotesk" data-id="element-1731">
                      Key factors
                    </h4>
                    <div className="flex flex-wrap gap-2 mb-6" data-id="element-1732">
                      <span className="border border-black rounded-full px-4 py-1 text-sm" data-id="element-1733">
                        Role
                      </span>
                      <span className="border border-black rounded-full px-4 py-1 text-sm" data-id="element-1734">
                        Interests
                      </span>
                      <span className="border border-black rounded-full px-4 py-1 text-sm" data-id="element-1735">
                        Skills
                      </span>
                    </div>
                  </div>
                  <div className={`transition-all duration-300 ${activeTab === 'deep' ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-[100%] absolute top-0 left-0 right-0'}`} data-id="element-1736">
                    <h4 className="font-medium text-lg mb-3 font-sharp-grotesk" data-id="element-1737">
                      Match breakdown
                    </h4>
                    <div className="space-y-4" data-id="element-1738">
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1739">
                        <div className="flex justify-between items-center mb-1" data-id="element-1740">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1741">
                            Habits
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1742">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1743">
                              28%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1744" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1745">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '28%'
                      }} data-id="element-1746"></div>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1747">
                        <div className="flex justify-between items-center mb-1" data-id="element-1748">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1749">
                            Skills
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1750">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1751">
                              22%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1752" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1753">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '22%'
                      }} data-id="element-1754"></div>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1755">
                        <div className="flex justify-between items-center mb-1" data-id="element-1756">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1757">
                            Work
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1758">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1759">
                              19%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1760" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1761">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '19%'
                      }} data-id="element-1762"></div>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1763">
                        <div className="flex justify-between items-center mb-1" data-id="element-1764">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1765">
                            Biographical
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1766">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1767">
                              14%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1768" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1769">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '14%'
                      }} data-id="element-1770"></div>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1771">
                        <div className="flex justify-between items-center mb-1" data-id="element-1772">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1773">
                            Actions
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1774">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1775">
                              10%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1776" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1777">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '10%'
                      }} data-id="element-1778"></div>
                        </div>
                      </div>
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-colors" data-id="element-1779">
                        <div className="flex justify-between items-center mb-1" data-id="element-1780">
                          <h5 className="text-sm font-medium capitalize text-gray-700" data-id="element-1781">
                            Online
                          </h5>
                          <div className="flex items-center gap-1.5" data-id="element-1782">
                            <span className="text-sm font-sharp-grotesk font-medium" data-id="element-1783">
                              7%
                            </span>
                            <ChevronDown className="w-3.5 h-3.5 text-gray-500" data-id="element-1784" />
                          </div>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1785">
                          <div className="bg-black h-2 rounded-full transition-all duration-700" style={{
                        width: '7%'
                      }} data-id="element-1786"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Share Profile Modal */}
      {showShareModal.show && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center" data-id="element-1787">
          <div className="fixed inset-0 bg-black/30 transition-opacity" onClick={closeShareModal} data-id="element-1788"></div>
          <div className={`bg-white w-full max-w-md rounded-t-xl sm:rounded-xl overflow-hidden transform transition-all duration-300 ease-out ${showShareModal.closing ? 'animate-slide-down' : 'animate-slide-up'}`} data-id="element-1789">
            <div className="p-6" data-id="element-1790">
              <div className="flex items-center justify-between mb-6" data-id="element-1791">
                <h3 className="text-xl font-medium font-sharp-grotesk" data-id="element-1792">
                  Share Profile
                </h3>
                <button onClick={closeShareModal} className="text-gray-500 hover:text-gray-700" data-id="element-1793">
                  <X className="w-5 h-5" data-id="element-1794" />
                </button>
              </div>
              <div className="mb-6" data-id="element-1795">
                <h4 className="font-medium text-sm text-gray-500 mb-2" data-id="element-1796">
                  Profile Link
                </h4>
                <div className="flex items-center" data-id="element-1797">
                  <div className="flex-1 bg-gray-100 rounded-l-lg p-3 truncate text-sm cursor-pointer hover:bg-gray-200 transition-colors" onClick={openPublicProfile} data-id="element-1798">
                    https://thesocialhub.com/profile/sophia
                  </div>
                  <button onClick={handleCopyLink} className="bg-black text-white p-3 rounded-r-lg hover:bg-gray-800 transition-colors" data-id="element-1799">
                    {copySuccess ? <CheckCircle2 className="w-5 h-5" data-id="element-1800" /> : <Copy className="w-5 h-5" data-id="element-1801" />}
                  </button>
                </div>
                {copySuccess && <p className="text-green-600 text-xs mt-1" data-id="element-1802">
                    Link copied to clipboard!
                  </p>}
              </div>
              <div className="mb-6" data-id="element-1803">
                <h4 className="font-medium text-sm text-gray-500 mb-2" data-id="element-1804">
                  Privacy Settings
                </h4>
                <div className="flex gap-3" data-id="element-1805">
                  <button onClick={() => setPrivacyOption('private')} className={`flex items-center gap-2 border rounded-lg px-4 py-2 flex-1 ${privacyOption === 'private' ? 'border-black' : 'border-gray-200'}`} data-id="element-1806">
                    <Lock className="w-4 h-4" data-id="element-1807" />
                    <span className="text-sm" data-id="element-1808">Private</span>
                  </button>
                  <button onClick={() => setPrivacyOption('public')} className={`flex items-center gap-2 border rounded-lg px-4 py-2 flex-1 ${privacyOption === 'public' ? 'border-black' : 'border-gray-200'}`} data-id="element-1809">
                    <GlobeIcon className="w-4 h-4" data-id="element-1810" />
                    <span className="text-sm" data-id="element-1811">Public</span>
                  </button>
                </div>
              </div>
              <div className="mb-6" data-id="element-1812">
                <h4 className="font-medium text-sm text-gray-500 mb-3" data-id="element-1813">
                  Share on
                </h4>
                <div className="grid grid-cols-4 gap-4" data-id="element-1814">
                  <button className="flex flex-col items-center gap-2" data-id="element-1815">
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-1816">
                      <Linkedin className="w-5 h-5 text-blue-600" data-id="element-1817" />
                    </div>
                    <span className="text-xs" data-id="element-1818">LinkedIn</span>
                  </button>
                  <button className="flex flex-col items-center gap-2" data-id="element-1819">
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-1820">
                      <Twitter className="w-5 h-5 text-blue-500" data-id="element-1821" />
                    </div>
                    <span className="text-xs" data-id="element-1822">Twitter</span>
                  </button>
                  <button className="flex flex-col items-center gap-2" data-id="element-1823">
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-1824">
                      <Facebook className="w-5 h-5 text-blue-700" data-id="element-1825" />
                    </div>
                    <span className="text-xs" data-id="element-1826">Facebook</span>
                  </button>
                  <button className="flex flex-col items-center gap-2" data-id="element-1827">
                    <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center" data-id="element-1828">
                      <Instagram className="w-5 h-5 text-pink-600" data-id="element-1829" />
                    </div>
                    <span className="text-xs" data-id="element-1830">Instagram</span>
                  </button>
                </div>
              </div>
              <button className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors" onClick={closeShareModal} data-id="element-1831">
                Done
              </button>
            </div>
          </div>
        </div>}
    </div>;
}